<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">List of Trading 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="print()">
              <i class="fa fa-print"></i> Print
          </button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
              <b-input-group-prepend><label>Trading Doc.</label></b-input-group-prepend>
              <b-form-input v-model="tblData.Tradingno" placeholder="Trading Number"></b-form-input>
              <b-input-group-append><span class="input-group-text"> Buyer </span></b-input-group-append>
              <b-form-input v-model="tblData.pembeli" placeholder="Trading to"></b-form-input>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Trading Item</label></b-input-group-prepend>
              <b-form-input v-model="tblData.itemname" placeholder="Name/Description"></b-form-input>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Trading Date</label></b-input-group-prepend>
              <b-form-input v-model="tblData.tgl1" type="date" placeholder="from date"></b-form-input>
              <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
              <b-form-input v-model="tblData.tgl2" type="date" placeholder="until date"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
              <b-input-group-prepend><label>Store/Warehouse</label></b-input-group-prepend>
              <b-form-select v-model="tblData.idStore" :plain="true" :options="dataList.warehouse"></b-form-select>
              <b-input-group-append><span class="input-group-text"> Input By </span></b-input-group-append>
              <b-form-input v-model="tblData.createby" placeholder="Trading to"></b-form-input>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend><label>Item Category</label></b-input-group-prepend>
              <b-form-input v-model="tblData.headcategory" placeholder="Head Category"></b-form-input>
              <b-input-group-append><span class="input-group-text">-</span></b-input-group-append>
              <b-form-input v-model="tblData.nmcategory" placeholder="Category"></b-form-input>
              <b-form-checkbox v-model="tblData.barangbarter" value="1" unchecked-value="" class="ml-2 pt-1">Item Barter</b-form-checkbox>
          </b-input-group>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Posting Status</label></b-input-group-prepend>
                <b-form-select v-model="tblData.posting" :plain="true" :options="dataList.openStatus"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-row>
                <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-row>
            </b-col>
          </b-row>  
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblData.tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
        show-empty
      >
        <template v-slot:cell(nomor)="data">
          <span v-if="(data.item.isReturn == 1)" style="color:red">{{data.item.nomor}}</span>
          <span v-else>{{data.item.nomor}}</span>
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(qtyTrading)="data">
          <span v-if="(data.item.isReturn == 1)" style="color:red">{{data.item.qtyTrading}} &nbsp; {{data.item.invunitom}}</span>
          <span v-else>{{data.item.qtyTrading}} &nbsp; {{data.item.invunitom}}</span>
        </template>
        <template v-slot:cell(valueTrading)="data">
          <span v-if="(data.item.valueTrading)">{{data.item.matauang}} &nbsp;{{data.item.valueTrading|numFormat}}</span>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-logistic {
}
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import trading from "../../apis/logistic_trading";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      disabledRetur:false,
      horizontal: true,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      model:{},
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment().format('YYYY-MM-DD'),
        sortBy: 'nomor',
        sortDesc: false,
        DimCol:'Dim1',
        posting:'0',
        idStore:'',
        headcategory:'',
        nmcategory:'',
        tblFields:[
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trading Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Trading Date",
            sortable: true
          },
          {
            key: "pembeli",
            label: "Trading To(Buyer)",
            sortable: true
          },
          {
            key: "itemname",
            label: "Item Inventory",
            sortable: true
          },
          {
            key: "qtyTrading",
            label: "Quantity",
            thStyle: "width:100px",
            tdClass: "text-right"
          },
          {
            key: "valueTrading",
            label: "Value",
            thStyle: "width:120px",
            tdClass: "text-right"
          },
          {
            key: "itemcategory",
            label: "Item Category",
            sortable: true
          },
          {
            key: "barangbarter",
            label: "Item Barter",
            thStyle: "width:40px",
            sortable: true
          },
          {
            key: "namaStore",
            label: "Store/Warehouse",
            sortable: true
          },
          {
            key: "createby",
            label: "Input By",
            thStyle: "width:100px",
            sortable: true
          },
        ]
      },
      dataList: {
        openStatus: dropdown.postingStatus,
        warehouse:[],
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
      this.dataList.warehouse = await trading.store(); 
  },  
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
   data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.TradingList) {
            this.tblData[key] = filter.TradingList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.TradingList.tgl1 || '';
          this.tblData.tgl2=filter.TradingList.tgl2 || '';
          this.showFilter=filtered;
          delete filter.TradingList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.isLoading=true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await trading.list(this.tblData);   
      this.items = list; 
      this.isLoading=false;
     return list;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.itemname=  '';
        this.tblData.itemno=  '';
        this.tblData.nomor=  '';
        this.tblData.pembeli=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.posting=  '';
        this.tblData.idStore='';
        this.tblData.headcategory='';
        this.tblData.nmcategory='';
    },
    saveFilter() {
      const keys = [, 'uraian', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'posting', 'pembeli', 'employee', 'idStore', 'itemname', 'itemno', 'nmcategory', 'headcategory'];
      let filtered = false;
      const TradingList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              TradingList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          TradingList.page=this.tblData.page;
          TradingList.limit=this.tblData.limit;
          TradingList.sortBy=this.tblData.sortBy;
          TradingList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.TradingList=TradingList;
          this.$store.commit("filter", filter);
      }
    },    
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    add(){
      this.saveFilter();
      router.push({name :"logistic.tradingform"});
    },
    edit: function() {
        if (this.model.tradingKey) {
          if (this.model.isReturn==0) {
              this.saveFilter();
              router.push({name :'logistic.tradingform', params: { tradingKey: this.model.tradingKey}});
          } else if ((this.model.isReturn==1) && (this.model.tradingKeyB4)) {
              this.saveFilter();
              router.push({name :'logistic.Tradingretur', params: { tradingKey: this.model.tradingKey}});
           }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    retur: function() {
        if (this.model.tradingKey) {
          if(this.model.isReturn === 1){
            toastr.warn('Please select other row that want to be Retur!');
          }else{
            router.push({name :'logistic.Tradingretur', params: { tradingKeyB4: this.model.tradingKey}});
          }
          
        } else {
            toastr.warn('Please select a row that want to be Retur!');
        }
    },
    deleteConfirm() {
        if (this.model.tradingKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await trading.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.tradingKey==this.model.tradingKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      if(record.isReturn === 1){
        this.disabledRetur=true;
      }else{
        this.disabledRetur=false;
      }

      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    posting: async function () {
        if (this.model.tradingKey) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await trading.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await trading.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    print: async function()
    {
      if (this.model.tradingKey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await trading.print(this.model);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    printjv: async function()
    {
      if (this.model.tradingKey) {
          this.isLoading=true;
          try {
              this.showReport=true;
              this.reportUrl= await trading.printjv(this.model);
              this.isLoading=false;
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await trading.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("/logistic/home");
    },    
  }
};
</script>
